var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.001,
    height: 24,
    viewBox: "0 0 34.001 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Personal_Info",
    "data-name": "Personal Info",
    transform: "translate(-1505.999 -352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521",
    transform: "translate(-27 9.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(1539.173 343)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "fill",
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(-0.172 -0.189)",
    fill: "#58299c"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M26.457,9.561H0A8.818,8.818,0,0,1,2.273,3.753,13.066,13.066,0,0,1,8.126,0a10.5,10.5,0,0,0,5.1,1.273A10.5,10.5,0,0,0,18.332,0a13.073,13.073,0,0,1,5.853,3.753,8.826,8.826,0,0,1,2.272,5.808Z",
    transform: "translate(1532.999 357.249)",
    fill: "#58299c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke",
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    transform: "translate(1527 360)",
    fill: "#fff",
    stroke: "#58299c",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none",
    className: "no-stroke"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "none",
    className: "no-fill"
  })), /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    id: "Path_728",
    "data-name": "Path 728",
    d: "M17121.584,5744.841l2.678,1.949,2.658-4.816",
    transform: "translate(-15589.252 -5376.382)",
    fill: "none",
    stroke: "#58299c",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalInfo);
export default __webpack_public_path__ + "static/media/PersonalInfo.e28e460b.svg";
export { ForwardRef as ReactComponent };